import React, { useState } from 'react';
import './OptimizedImage.css';

/**
 * Imagen optimizada para carga rápida y buena experiencia de uso.
 *
 * - Placeholder CSS inmediato (sin peticiones extra ni dominios externos).
 * - Lazy loading nativo del navegador (loading="lazy").
 * - Decodificación asíncrona (decoding="async") para no bloquear el hilo principal.
 * - Transición suave al cargar la imagen (fade-in).
 *
 * No usa scripts de terceros, CDN externos ni técnicas que puedan activar
 * filtros de seguridad (p. ej. Safe Browsing). Todo el contenido viene
 * del mismo origen (API_BASE_URL o props).
 */
const OptimizedImage = ({
  src,
  alt = '',
  className = '',
  style = {},
  loading = 'lazy',
  /** Prioridad: 'high' para above-the-fold (ej. logo), 'low' por defecto */
  fetchPriority,
  /** Proporción aproximada (ej. 16/9) para reservar espacio y evitar saltos de layout */
  aspectRatio,
  /** Clase adicional para el contenedor (placeholder + imagen) */
  wrapperClassName = '',
  ...imgProps
}) => {
  const [loaded, setLoaded] = useState(false);

  const wrapperStyle = {
    ...(aspectRatio && { aspectRatio: typeof aspectRatio === 'number' ? aspectRatio : aspectRatio }),
  };

  return (
    <span
      className={`optimized-image-wrapper ${loaded ? 'optimized-image-wrapper-loaded' : ''} ${wrapperClassName}`}
      style={wrapperStyle}
    >
      <span
        className="optimized-image-placeholder"
        aria-hidden="true"
      />
      <img
        src={src}
        alt={alt}
        className={`optimized-image ${loaded ? 'optimized-image-loaded' : ''} ${className}`}
        style={style}
        loading={loading}
        decoding="async"
        {...(fetchPriority && { fetchPriority })}
        onLoad={() => setLoaded(true)}
        {...imgProps}
      />
    </span>
  );
};

export default OptimizedImage;
